import mapboxgl from '!mapbox-gl' // eslint-disable-line import/no-webpack-loader-syntax,import/no-unresolved

export const initializeAccessToken = () => {
  const { REACT_APP_MAP_BOX_KEY: MAP_BOX_KEY } = process.env
  mapboxgl.accessToken = MAP_BOX_KEY
}
